import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {setGetHistoryBonusGetById} from '../../store/thunk/setGetHistoryBonusGetById';
import TableCasino from './block/table';
import {ReactComponent as ArrowRight} from '../../../../../@casino/img/right-arrow.svg';
import {ReactComponent as ArrowDown} from '../../../../../@casino/img/down-arrow.svg';
import {columns, getRows, useStyles} from './helpers';

const BlockBonus = ({id}) => {
    const dispatch = useDispatch();
    const classes = useStyles();

    const [bonuses, setBonuses] = React.useState(false);

    React.useEffect(() => {
        if (bonuses) {
            dispatch(setGetHistoryBonusGetById({
                id,
                page: 1,
                rowsPerPage: 5
            }));
        }
    }, [bonuses, id]);

    const bonusesArr = useSelector(state => state.users.bonuses_history);
    const rows = React.useMemo(() => getRows(bonusesArr.data), [bonusesArr])
    
    return (
        <div>
            <div 
                className={classes.wrapTitle}
                onClick={() => {
                    setBonuses(!bonuses)
                }}
            >
                <span
                    className={classes.title}
                >
                    Бонусы
                </span>
                {
                    !bonuses && 
                    <ArrowRight className={classes.arrow}/>
                }
                {
                    bonuses && 
                    <ArrowDown className={classes.arrow}/> 
                }        
            </div>
            <div>
                {
                    bonuses && id &&
                    <TableCasino
                        allPage={bonusesArr.count}
                        width={1280}
                        perPage={10}
                        columns={columns}
                        rows={rows}
                        changeRowsPerPage={(v) => dispatch(setGetHistoryBonusGetById({
                            page: 1,
                            rowsPerPage: v.rowsPerPage,
                            id,
                        }))}
                    /> 
                }
            </div>
        </div>
    )
}

export default BlockBonus;